/**
 * The sections of the admin area, in nav order. Paths are under /admin. permission is the one the API checks for the
 * section (internal/admin/roles.go); a section without one is for every admin. menu sections stay out of the main nav
 * and are reached from the account menu at the bottom of the sidebar.
 */
export const adminSections: { path: string; label: string; permission?: string; menu?: boolean }[] = [
    { path: "", label: "Översikt" },
    { path: "nodlage", label: "Nödläge", menu: true },
    { path: "poddar", label: "Poddar", permission: "podcast.edit" },
    { path: "kategorier", label: "Kategorier", permission: "categories" },
    { path: "jobb", label: "Jobb", permission: "jobs" },
    { path: "fokus", label: "Fokusområden", permission: "curate" },
    { path: "moderering", label: "Moderering", permission: "suggestions" },
    { path: "anvandare", label: "Användare", permission: "users" },
    { path: "klienter", label: "Klienter", permission: "oauth" },
    { path: "logg", label: "Logg", permission: "audit" },
];

/**
 * The sections a role may use. With no permissions known (the server did not say), every section is shown: the API
 * still refuses what the role may not do.
 */
export const sectionsFor = (permissions: string[] | null) =>
    adminSections.filter(
        (s) => s.permission === undefined || permissions === null || permissions.includes(s.permission)
    );

/** True for /admin and everything under it, but not for paths that only start with the same letters. */
export const isAdminPath = (pathname: string) => pathname === "/admin" || pathname.startsWith("/admin/");
